import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { DataEditWidget as mainModule } from './main';
import { init as mainTheme } from './themes/main';
import * as Config from './config';

declare var require: any;

require('../sass-main/pdc-widget-data-edit.sass');
require('../../../_common/libs/dx25/css/dx.common.css');
require('../../../_common/libs/dx25/css/dx.light.css');

export class DataEditWidget extends WidgetBase {
    public static _name: string = Config.name;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;
    public static themeModule = mainTheme;

    public static containersNum: number = 1;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                const module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-data-edit'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(DataEditWidget);
